require("../sass/style.scss");

require('./vendor/slick.js');
require('./vendor/wow.min.js');

jQuery(document).ready(function () {
	// Title Animation		
	jQuery(".animate-elm").addClass("is_on_screen");
	 
	// Partners Logo Slider
	jQuery('.logo-slider').slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 2000,
		dots: true,
		prevArrow:"<span class='slick-prev'><i class='icon-angle-left' aria-hidden='true'></i></span>",
		nextArrow:"<span class='slick-next'><i class='icon-angle-right' aria-hidden='true'></i></span>",
		responsive: [
		    {
		      breakpoint: 992,
		      settings: {
		        slidesToShow: 3,
		        slidesToScroll: 1,
		      }
		    },
		    {
		      breakpoint: 579,
		      settings: {
		        slidesToShow: 2,
		        slidesToScroll: 1,
		      }
		    },		    
		  ]
	});


	jQuery(document).on('click', '#header .header-navbar-toggle', function(){
		jQuery('#header .mobile-nav-menu').slideToggle();

	});

	var win = jQuery(window);
	var slideUpMods = jQuery('.animate');
	
	function IsElementVisible (element, partial) {
		var jQueryt           = jQuery(element),
			jQueryw       = jQuery(window),
			viewTop       = jQueryw.scrollTop(),
			viewBottom    = viewTop + jQueryw.height(),
			_top          = jQueryt.offset().top,
			_bottom       = _top + jQueryt.height(),
			compareTop    = partial === true ? _bottom : _top,
			compareBottom = partial === true ? _top : _bottom;
    
		return ((compareBottom <= viewBottom) && (compareTop >= viewTop));
	}
	
	function runAnimations() {
		var isMobile = window.innerWidth < 768;		
		
		slideUpMods = jQuery('.animate');
		
  		slideUpMods.each(function(i, el) 
		{
			var el = jQuery(el);
			
			if (isMobile)
			{
				el.css('opacity', '1.0');
			}
			else
			{						
				if (IsElementVisible(el, false))
				{
					var classNames = el.attr("class").split(' ');
					
					for (var i = 0; i < classNames.length ; i++)
					{
						var clName = classNames[i];
						if (clName.startsWith('--'))
						{
							el.removeClass(clName);
							el.removeClass('animate');
							clName = clName.replace('--', '');
							el.addClass('animated'); 
							el.addClass(clName); 
						}
					};
				} 
			}
		})
	}
	
	runAnimations();

    win.scroll(function(event) {  
		runAnimations();
  	}); 

  	jQuery(document).ready(function($){
    $(window).scroll(function(){
        if ($(this).scrollTop() > 80) {
            $('#back-to-top').addClass('on');
        } else {
            $('#back-to-top').removeClass('on');
        }
    });
    $('#back-to-top').click(function(){
        $("html, body").animate({ scrollTop: 0 }, 500);
        //$("html, body").scrollTop(0); //For without animation
        return false;
    });
});

});




// WEBPACK FOOTER //
// ./src/js/entry.es6